import type { LeaderboardEntry } from "@/app/achievements/page"
import { Star } from "lucide-react"

interface LeaderboardEntryProps {
  entry: LeaderboardEntry
}

export default function LeaderboardEntryComponent({ entry }: LeaderboardEntryProps) {
  const getRankColor = (rank: number) => {
    if (rank === 1) return "bg-amber-100"
    if (rank === 2) return "bg-slate-200"
    if (rank === 3) return "bg-indigo-100 border-2 border-indigo-600"
    return "hover:bg-slate-100"
  }

  const getRankTextColor = (rank: number) => {
    if (rank === 1) return "text-amber-600"
    if (rank === 2) return "text-slate-600"
    if (rank === 3) return "text-indigo-600"
    return "text-slate-500"
  }

  const getStarColor = (rank: number) => {
    if (rank === 1) return "text-amber-500"
    if (rank === 2) return "text-slate-500"
    if (rank === 3) return "text-indigo-600"
    return "text-slate-400"
  }

  return (
    <div className={`flex items-center gap-4 p-3 rounded-xl transition-colors ${getRankColor(entry.rank)}`}>
      <span className={`text-lg font-bold w-6 text-center ${getRankTextColor(entry.rank)}`}>{entry.rank}</span>
      <img
        alt={`Avatar of ${entry.name}`}
        className="w-10 h-10 rounded-full"
        src={entry.avatar || "/placeholder.svg"}
      />
      <p className={`font-semibold flex-1 ${entry.isCurrentUser ? "text-indigo-600" : "text-slate-900"}`}>
        {entry.name}
        {entry.isCurrentUser && " (You)"}
      </p>
      <div
        className={`flex items-center gap-1 font-bold ${entry.isCurrentUser ? "text-indigo-600" : "text-slate-900"}`}
      >
        <Star className={`w-4 h-4 ${getStarColor(entry.rank)}`} />
        <span>{entry.points.toLocaleString()}</span>
      </div>
    </div>
  )
}
